import { Box, Callout, Flex, Spinner, Text } from '@radix-ui/themes'
import type { ReactNode } from 'react'

interface TabStateProps {
  loading: boolean
  error: string | null
  isEmpty?: boolean
  emptyMessage?: string
  children: ReactNode
}

// Keeps a tab's loading or failure state inside the tab rather than blanking the whole page.
export const TabState = ({ loading, error, isEmpty = false, emptyMessage, children }: TabStateProps) => {
  if (error) {
    return (
      <Callout.Root color="red">
        <Callout.Text>{error}</Callout.Text>
      </Callout.Root>
    )
  }
  if (loading) {
    return (
      <Flex align="center" gap="2" py="4">
        <Spinner size="2" />
        <Text color="gray">Loading…</Text>
      </Flex>
    )
  }
  if (isEmpty) {
    return (
      <Box py="6">
        <Text color="gray">{emptyMessage}</Text>
      </Box>
    )
  }
  return <>{children}</>
}
